import { call, patch, post } from "@/services/api";

// "Accès" — modules and home module per user (admins only).
export type StaffRow = {
  id: number; name: string | null; email: string; active: boolean; is_admin: boolean;
  modules: string[]; home_module: string | null; uses: string[]; read_only_modules: string[];
};
export const fetchStaffs = () => call<{ staffs: StaffRow[]; modules: string[] }>(`/api/v1/staffs`);
export const createStaff = (b: { name: string; email: string; password: string; modules: string[]; home_module: string | null }) =>
  post<StaffRow>(`/api/v1/staffs`, b);
export const updateStaff = (id: number, b: Partial<{ modules: string[]; read_only_modules: string[]; home_module: string | null; active: boolean; is_admin: boolean; password: string }>) =>
  patch<StaffRow>(`/api/v1/staffs/${id}`, b);
